module.exports = __webpack_public_path__ + "static/icon3-c3631c652abe1185b1874da24af0b7c7.png";